$("#school_search_button").bind("click", function() {
  $("form#sign_up").attr("novalidate", "novalidate");//.submit();
});

$(".m-sign-up__form .m-dropdown .dropdown-menu li a").bind("click", function(e) {
  e.preventDefault();

  var selected = $(this);
  [
    { id: "#school_name", data: "name" },
    { id: "#school_street_address", data: "street" },
    { id: "#school_city", data: "city" },
    { id: "#school_postcode", data: "postcode" },
    { id: "#school_county", data: "county" },
    { id: "#school_country", data: "country" },
  ].forEach(function(value) { $(value.id).val(selected.data(value.data)); });

  selected.parent().parent().parent().children("button").text(selected.text());
});

$("#school_search").on('input', function() {
  if ($(this).val().length === 0) {
    $("#school_search_button").prop("disabled", true); return;
  }
  $("#school_search_button").prop("disabled", false);
});

$(".toggle-school-fields").bind("click", function(e) {
  e.preventDefault(); $(".school-fields").addClass("open");
});

$('#accept-privacy-policy').bind('click', function() {
  if ($(this).prop('checked')) {
    $('#create_account_button').removeClass('btn-disabled').removeAttr('disabled');
  } else {
    $('#create_account_button').addClass('btn-disabled').attr('disabled', 'disabled');
  }
});